<template>
  <v-dialog v-model="showProgress" width="500" persistent>
    <v-card class="bg-white rounded-xl p-5">
      <v-card-text class="text-primary-900">
        {{ progressMessage ? progressMessage : $t("loading") }}
        <v-progress-linear
          indeterminate
          color="text-primary-900"
          class="mb-0 mt-2"
        ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["showProgress", "progressMessage"]),
  },
};
</script>
